import { render, staticRenderFns } from "./PseudoSelectComponent.vue?vue&type=template&id=524577de&"
import script from "./PseudoSelectComponent.vue?vue&type=script&lang=js&"
export * from "./PseudoSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports